import { createAsyncThunk } from '@reduxjs/toolkit';
import { TFormApplications } from '~/store/remote-banking-contacts/types.ts';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import { TBaseRequest } from '~/store/types.ts';
import { ERROR_CODES } from '~/constants/errorCodes.ts';
import { errorMessages } from '~/constants/errorMessages.ts';
import { TThunkError } from '~/store/covenants/types';

export const remoteBankContactResponsiblePersonsForm = createAsyncThunk<null, TFormApplications>(
  'remoteBankingContacts/responsiblePersonsForm',
  async ({ applicationId, form, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      };

      const response = await api.put(
        `/remote-banking-contacts/applications/${applicationId}/persons`,
        form,
        { headers }
      );

      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const remoteBankContactCurrentContactDetailsInfo = createAsyncThunk<
  { documentId: string },
  TBaseRequest
>(
  'remoteBankingContacts/currentContactDetailsInfo',
  async ({ applicationId, token }, { rejectWithValue }) => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      };

      const response = await api.post(
        `/remote-banking-contacts/applications/${applicationId}/documents/current-contact-details-info`,
        null,
        { headers }
      );

      return response.data;
    } catch (error) {
      if (
        (error as { data: TThunkError })?.data?.errorCode ===
        ERROR_CODES.EDR_NAIS_API_ERROR.toString()
      ) {
        return rejectWithValue({ message: errorMessages.SERVICE_UNAVAILABLE });
      }
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
